<template>
<div class="option_wrap animate_class" :class="selectedstatus" @click="selectItem">
<div class="grid  pt-0 pb-0 mt-0">

<div class="col-10 md:col-11 pt-0 pb-0">
{{labeltext}}
</div>

<div class="col-2 md:col-1 pt-0 pb-0">
	<div class="flex align-items-center justify-content-end ">
	<i class="pi pi-check pr-3" v-if="selectedstatus=='option_wrap_selected'"></i>
	</div>
</div>


</div>
</div>
</template>

<script>
export default {

  name: 'MultiSelectOption',
  props:["item","selected","nulled","readonly"],
  data () {
    return {

    }
  },
   computed:{
  	labeltext()
  	{
  		if(this.item.translations.length)
  		{
  			let translation = this.item.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
  			return translation.translation
  		}
  		else
  		{
  			return this.item.name
  		}
  		
  	},
  	selectedstatus()
  	{
      if(this.nulled)
      {
        if(this.readonly)
        {
          return ""
        }
        else
        {
          return "nulled_option"
        }
      }
      else
      {
        if(this.selected && this.selected.length)
        {
          if(this.selected.includes(this.item.id))
          {
            return "option_wrap_selected"
          }
          else
          {
            return ""
          }
        }
        else
        {
          return ""
        }
        
      }


  	},
  },
  mounted()
  {
  	console.log("SelectOption")
    console.log(this.item)
    console.log(this.selected)
  },
  methods:{
  	selectItem()
  	{
  		if(!this.readonly)
          {
            this.$emit("optionSelected",this.item.id)
          }
  	}
  }
};
</script>

<style lang="css" scoped>
</style>